export default __webpack_public_path__ + "static/media/tree-logo.e176a51d.png";